module.exports = __webpack_public_path__ + "static/img/role-de.0667774.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/layer3/role-5/role-de.png
// module id = FbFL
// module chunks = 1